import createBrowserHistory from 'history/createBrowserHistory';

export const createHistory = createBrowserHistory();
